module.exports = __webpack_public_path__ + "static/img/dispatch.781b277.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/order-process/dispatch.png
// module id = BZXK
// module chunks = 1